import React from 'react';
import { connect } from 'react-redux';
import { CssBaseline, AppBar, Toolbar, Button, Box, Divider, Grid, Autocomplete, TextField } from '@mui/material/';
import { BasePageStyles } from '../../hooks/styles';
import clsx from 'clsx';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useHistory } from "react-router-dom";
import { Interweave, Node } from 'interweave';

type ProductThumbProps = {
	productInfo: any
};

const ProductThumbComponent: React.FC<ProductThumbProps> = props => {
	
	const classes = BasePageStyles();
	const history = useHistory(); 
 	const routeChange = (path: string) =>{ 
  	history.push(path);
  }

	return (
		<div className={classes.productThumbContainer}>
			<div onClick={() => routeChange( props.productInfo?.link)} style={{
					cursor: 'pointer'
				}}>
				<img src={props.productInfo?.thumbnail} style={{maxWidth: 250, maxHeight: 250}} />
				<div style={{
					fontWeight: 'bold',
					fontSize: 16
				}}>
					{props.productInfo?.shortName || props.productInfo?.name} {props.productInfo?.isPreorder && <span>
							(pre-order)
						</span>}
				</div>
				<div style={{
					fontSize: props.productInfo?.isComingSoon ? 18 : 12
				}}>
					<Interweave content={props.productInfo?.description || ''} />
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => ({
	
});

const mapDispatchToProps = (dispatch: any) => ({
	
});

const ProductThumbConnected = connect(mapStateToProps, mapDispatchToProps)(ProductThumbComponent);
export default ProductThumbConnected;






